module.exports = __webpack_public_path__ + "assets/img/5_1367.2a4ff6a0.jpg";